module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative-date-choser"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('statistics.time_range')) + ":\n  ")]), _vm._v(" "), _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: choice,
      staticClass: "relative-date-choser-choice",
      class: {
        'is-active': choice == _vm.date
      },
      on: {
        "click": function($event) {
          return _vm.choose(choice)
        }
      }
    }, [(choice == 1) ? _c('span', [_vm._v("\n      24 " + _vm._s(_vm.$t('statistics.hours')) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(choice) + " " + _vm._s(_vm.$t('statistics.days')) + "\n    ")])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f9aa8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/RelativeDateChoser.vue
// module id = 1946
// module chunks = 0